import { render } from "./postitem.vue?vue&type=template&id=99f57b2c&scoped=true"
import script from "./postitem.vue?vue&type=script&lang=js"
export * from "./postitem.vue?vue&type=script&lang=js"

import "./postitem.vue?vue&type=style&index=0&id=99f57b2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f57b2c"]])

export default __exports__